<template>
  <transition name="fade">
    <div class="limited-time-rule-popup" v-if="visible">
      <div class="rule-popup">
        <p class="dialog-title">{{ letter.limitedTimeActivityRule }}</p>
        <p class="rule-content" v-html="rules"></p>
        <Button class="close-btn" @click="hidePopup"></Button>
      </div>
    </div>
  </transition>
</template>

<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import { clickButton, locationType } from '@plugins/biPoint/_configWebstoreV1';
import { timestampToDateFormat } from '@utiles/officialStore';
export default {
  name: 'limitedTimeRulePopup',
  props: ['visible'],
  data() {
    return {};
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      gameId: state => state.gameId,
      limitedTimeActivityMonthStart: state =>
        state.event.limitedTimeActivityMonthStart,
      limitedTimeActivityMonthEnd: state =>
        state.event.limitedTimeActivityMonthEnd
    }),
    ...mapGetters(['gameInfoConfig']),
    rules() {
      const ruleNum = this.gameInfoConfig.limitedTimeActivity.ruleNum || 0;
      const startDate = timestampToDateFormat(
        this.limitedTimeActivityMonthStart
      );
      const endDate = timestampToDateFormat(this.limitedTimeActivityMonthEnd);
      let ruleHtml = '';
      for (let i = 1; i <= ruleNum; i++) {
        ruleHtml +=
          this.letter[`limitedTimeActivity${this.gameId}Rule${i}`]
            .replace('${startDate}', startDate)
            .replace('${endDate}', endDate) + '<br>';
      }
      return ruleHtml;
    }
  },
  methods: {
    hidePopup() {
      this.$emit('onClose');
      clickButton({
        btnName: 'close_eventsrule',
        locationKey: locationType.eventsRulePopup
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@assets/scss/officialStore/officialStore.scss';
.limited-time-rule-popup {
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 101;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);

  .rule-popup {
    position: relative;
    background-size: 100% 100%;
    @psetbg ('common-popup.png');

    .rule-content {
      height: 320px;
      padding: 0 42px;
      line-height: 30px;
      font-size: 18px;
      color: var(--global-tip-popup-text);
      overflow-y: scroll;
      &::-webkit-scrollbar {
        display: none;
      }
    }
    .close-btn {
      position: absolute;
      @psetbg ('close.png');
    }
  }
}
</style>
